var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlHead5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 558,
    viewBox: "0 0 536 558",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Head / 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Hair",
    d: "M292.16 349.652C292.567 352.043 292.779 354.501 292.779 357.008C292.779 357.072 292.778 357.136 292.778 357.2C314.457 380.491 325.9 412.99 321.135 446.762C312.757 506.15 257.313 547.886 197.925 539.508L93.8152 524.82C34.4272 516.442 -7.3088 460.998 1.0712 401.61C6.97373 359.77 36.2378 326.691 73.7839 313.726C63.5685 298.344 58.7046 279.335 61.4714 259.725C66.5423 223.774 95.7037 196.857 130.294 193.021C127.467 183.701 126.569 173.65 128.013 163.415H128.015C133.341 125.657 168.593 99.1211 206.351 104.449C215.951 105.803 224.826 109.092 232.637 113.865C254.482 101.284 280.391 93.9995 308.174 93.9995C386.17 93.9995 449.398 151.412 449.398 222.234C449.398 293.056 386.17 350.467 308.174 350.467C302.759 350.467 297.416 350.191 292.16 349.652Z",
    fill: "#FCBDA4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.693 375.789C329.693 375.789 303.833 376.553 292.809 370.533L328.319 392.827L329.693 375.789Z",
    fill: "#CF3E83"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Face",
    d: "M266.833 317.165C253.338 305.378 231.161 299.601 231.131 279.236C231.119 272.082 235.303 259.694 250.745 259.672C270.317 259.642 268.772 281.785 268.54 284.25L268.517 284.375L268.527 284.377C268.521 284.44 268.517 284.472 268.517 284.472C270.741 285.338 272.971 285.411 275.196 284.819C291.065 284.999 331.378 280.187 353.857 230.023C358.591 235.005 363.927 239.379 369.723 243.067C386.44 253.676 407.047 258.599 428.129 256.15C426.832 281.484 419.402 345.792 387.333 367.122C374.149 375.89 350.145 376.97 329.693 375.79L325.005 433.876C325.005 433.876 262.541 406.65 259.964 399.223C278.824 394.442 292.778 377.354 292.778 357.008C292.778 339.223 282.115 323.926 266.833 317.165Z",
    fill: "#ED4848"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.912 284.428L400.712 320.308L383.542 319.964L385.912 284.428Z",
    fill: "#405FD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.155 285.984C369.785 293.152 365.571 298.736 360.739 298.458C355.907 298.18 352.289 292.144 352.657 284.976C353.027 277.808 357.241 272.224 362.073 272.502C366.905 272.78 370.523 278.818 370.155 285.984Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.529 284.839C415.159 292.007 410.945 297.591 406.113 297.313C401.281 297.035 397.663 290.999 398.031 283.831C398.401 276.663 402.615 271.077 407.447 271.355C412.279 271.633 415.897 277.671 415.529 284.839Z",
    fill: "#0D0B6D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M379.328 337.149C379.328 337.149 368.14 340.761 356.93 328.295",
    stroke: "#1C295E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    opacity: 0.401762,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M329.651 375.789C329.651 375.789 303.789 376.553 292.767 370.531L328.277 392.825L329.651 375.789Z",
    fill: "black"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlHead5);
export default __webpack_public_path__ + "static/media/Girl-Head-5.c0c68a74.svg";
export { ForwardRef as ReactComponent };